import React, { useState, useEffect } from 'react'
import axiosJWT from '../../JwtToken'

export const EditPenawaran = ({ rowID, getData, closeEdit, getPesan, setMsg }) => {

    const [potensialName, setPotensialName] = useState('')
    const [contactName, setContactName] = useState('')
    const [phoneNumber, setPhoneNumber] = useState('')
    const [email, setEmail] = useState('')
    const [nilaiPenawaran, setNilaiPenawaran] = useState('')
    const [information, setInformation] = useState('')
    const [file, setFile] = useState("")
    const [preview, setPreview] = useState("")

    useEffect(() => {
        fetchData()
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    const fetchData = async () => {
        const response = await axiosJWT.get(`/api/request-procurement/${rowID}`)
        setPotensialName(response.data.potensialName)
        setContactName(response.data.contactName)
        setPhoneNumber(response.data.phoneNumber)
        setEmail(response.data.email)
        setNilaiPenawaran(response.data.nilaiPenawaran)
        setInformation(response.data.information)
        setPreview(response.data.filePath)
    }

    const loadFile = (e) => {
        const file = e.target.files[0]
        setFile(file)
        setPreview(URL.createObjectURL(file))
    }

    const getWaktuSekarang = () => {
        const d = new Date()
        const date = d.toISOString().split('T')[0] // Hasil: 2024-06-06
        const time = d.toTimeString().split(' ')[0] // Hasil: 09:59:42
        return `${date} ${time}`
    }

    const proses = async (e) => {
        e.preventDefault()

        if (file && file.size > 50 * 1024 * 1024) {
            setMsg('Ukuran file proposal (Maksimal 50 MB)!')
            return
        }

        try {
            const tanggal = getWaktuSekarang()
            const formData = new FormData()

            formData.append("contactName", contactName)
            formData.append("phoneNumber", phoneNumber)
            formData.append("email", email)
            formData.append("file", file)
            formData.append("nilaiPenawaran", nilaiPenawaran)
            formData.append("information", information)

            const response = await axiosJWT.put(`/api/request-procurement/revisi/${rowID}`, formData)

            getPesan()
            setMsg(response.data.msg)

            setTimeout(() => {
                getPesan()
                setMsg('')
                getData('')
                closeEdit()
            }, 2000)
        } catch (err) {
            getPesan()
            const errorMsg = (err.response && err.response.data && err.response.data.msg)
                ? err.response.data.msg
                : 'Maaf, proses pengiriman data gagal!'
            setMsg(errorMsg)

            setTimeout(() => {
                getPesan()
                setMsg('')
            }, 4000)
        }
    }

    return (<>
        <form onSubmit={proses} className="form-horizontal">
            <div className="row">
                <div className="form-group col-md-6">
                    <div className="row">
                        <div className="form-group col-md-12">
                            <label className="control-label">Kegiatan Usaha</label>
                            <div className="input-group">
                                <span className="input-group-addon"><i className="fa fa-briefcase"></i></span>
                                <input
                                    type="text"
                                    className="form-control"
                                    value={potensialName}
                                    readOnly
                                    style={{ backgroundColor: '#f5f5f5', cursor: 'not-allowed', fontWeight: 'bold' }}
                                    required
                                />
                            </div>
                        </div>

                        <div className="form-group col-md-12">
                            <label className="control-label">Nama Pemohon</label>
                            <div className="input-group">
                                <span className="input-group-addon"><i className="fa fa-user"></i></span>
                                <input type="text" className="form-control" onChange={(e) => setContactName(e.target.value)} value={contactName} required />
                            </div>
                        </div>
                        <div className="form-group col-md-12">
                            <label className="control-label">Nilai Penawaran</label>
                            <div className="input-group">
                                <span className="input-group-addon"><i className="fa fa-money"></i></span>
                                <input type="number" className="form-control" onChange={(e) => setNilaiPenawaran(e.target.value)} value={nilaiPenawaran} required />
                            </div>
                        </div>
                    </div>
                </div>
                <div className="form-group col-md-6">
                    <label className="control-label">File Pendukung</label>
                    {preview ? (<iframe width="100%" height="200" src={preview} title="Preview File" />) : (<img width="100%" height="200" src="/assets/img/no-image.png" title="Preview File" alt="Preview File" />)}
                    <input className="form-control mt-2" type="file" onChange={loadFile} accept=".pdf" />
                    <span className="badge d-inline-block text-wrap badge-danger mt-1">Upload file persyaratan menjadi 1 file dengan ekstensi .PDF</span>
                </div>
                <div className="form-group col-md-6">
                    <label className="control-label">No. Hp</label>
                    <div className="input-group">
                        <span className="input-group-addon"><i className="fa fa-phone"></i></span>
                        <input type="number" className="form-control" onChange={(e) => setPhoneNumber(e.target.value)} value={phoneNumber} required />
                    </div>
                </div>
                <div className="form-group col-md-6">
                    <label className="control-label">Email</label>
                    <div className="input-group">
                        <span className="input-group-addon"><i className="fa fa-envelope"></i></span>
                        <input type="email" className="form-control" onChange={(e) => setEmail(e.target.value)} value={email} required />
                    </div>
                </div>

                <div className="form-group col-md-12">
                    <label className="control-label">Informasi</label>
                    <div className="input-group">
                        <span className="input-group-addon"><i className="fa fa-text"></i></span>
                        <textarea className="form-control" onChange={(e) => setInformation(e.target.value)} value={information} required></textarea>
                    </div>
                </div>
            </div>
            <div className="modal-footer">
                <button className="btn btn-raised btn-success br-2 no-m" type="Submit"><i className="fa fa-edit"></i> Update</button>
                <button onClick={closeEdit} className="btn btn btn-raised btn-danger br-2 no-m">
                    <i className="fa fa-sign-out"></i> Tutup
                </button>
            </div>
        </form>
    </>)
}